class PagingMetadata {
    constructor(obj) {
        if (!obj) {
            return;
        }
        this.count = obj.count;
        this.total = obj.total;
        this.cursors = obj.cursors;
        this.hasNext = obj.hasNext;
        this.hasPrev = obj.hasPrev;
    }
}
export { PagingMetadata };
//# sourceMappingURL=pagingmetadata.js.map